import React from "react";
import { Typography, Select } from "antd";
import { createBaseBlock } from "./BaseBlock";
import { QuestionViewer } from "../../../dashboards/QuestionViewer";
import { DeepLinkType } from "pages/api/deep-links/types";
import { DashboardV1State } from "pages/api/deep-links/types";
import { useOrg } from "src/hooks/useOrg";
import { ContentViews } from "../../../explore/lib/useContentView";

// --- Data Types ---
export interface QueryBlockData {
  queryId: string;
  title: string;
  params: Record<string, any>;
  viz: {
    value: ContentViews;
    config: any;
  };
  style?: Record<string, any>;
  transparent?: boolean;
}

// --- Recipe ---
const embedBlockRecipe = {
  id: "embed-block",
  name: "Embed Block",
  globalKey: [],
  prefix: `{}`,
  format: {
    type: "json",
    fields: [],
    constraints: [],
  },
  validationRules: [],
};

// --- Parser ---
function queryBlockParser(data: any) {
  try {
    return {
      data: data[queryBlock.id],
    };
  } catch (error) {
    return {
      error: true,
      message: `Failed to parse embed block data: ${
        error instanceof Error ? error.message : String(error)
      }`,
      rawContent: data,
    };
  }
}

//TODO this should be a selector of possible queries
// --- Variants ---
const embedBlockVariants = [
  {
    id: "default",
    name: "Default",
    description: "Embed query with original formatting",
    settings: {},
  },
];

function QueryBlockRenderer(props: any) {
  const blockData = props.link?.json?.data?.[
    "06e332ba-09e3-4c46-a899-6cf847e1db4c"
  ] as QueryBlockData | undefined;
  const queryId = "06e332ba-09e3-4c46-a899-6cf847e1db4c";
  const filters = props.link?.json?.digestv2state?.filters || [];
  const defaultDateRange = props.link?.json?.digestv2state?.defaultDateRange;
  const { id: orgId } = useOrg();

  console.log("QueryBlock Debug:", {
    blockData: JSON.stringify(blockData),
    queryId,
    filters: JSON.stringify(filters),
    defaultDateRange: JSON.stringify(defaultDateRange),
    orgId,
    props: JSON.stringify(props.link?.json),
  });

  if (!queryId || !orgId) {
    return <div>No query selected or organization not found</div>;
  }

  const json: Pick<DashboardV1State, "data"> = {
    data: {
      [queryId]: {
        type: DeepLinkType.EXPLORE,
        title: blockData?.title || "Query",
        showTitle: true,
        centerTitle: false,
        style: blockData?.style || {},
        transparent: blockData?.transparent || false,
        state: {
          params: {
            ...blockData?.params,
            orgId,
            ...defaultDateRange,
            filters: [...(blockData?.params?.filters || []), ...filters],
          },
          viz: blockData?.viz || {
            value: "table" as ContentViews,
            config: {},
          },
        },
      },
    },
  };

  console.log("QueryBlock Constructed JSON:", JSON.stringify(json, null, 2));

  return (
    <div className="vzbl-panel-container">
      <QuestionViewer
        cardId={queryId}
        json={json}
        isLocked={false}
        onRemoveCard={() => {}}
        saveDashboard={async () => {}}
        searchState={{ filters }}
        setCardData={() => {}}
        setData={() => {}}
        setEditor={() => {}}
        setLayout={() => {}}
        source="embedded"
        unlock={() => {}}
      />
    </div>
  );
}

// --- Block Registration ---
const queryBlock = createBaseBlock({
  id: "query",
  name: "Query Block",
  description:
    "Embeds another query with its original formatting and respects topic filters.",
  recipe: embedBlockRecipe,
  variants: embedBlockVariants,
  parser: queryBlockParser,
  renderer: QueryBlockRenderer,
});

export { queryBlock };
